import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export type ContentConfig = {
  recommendImages?: boolean;
  enableTranslation?: boolean;
  enableExtendedKnowledge?: boolean;
};

export const contentConfigStateSegment = stateSegmentWithReset<ContentConfig>({
  recommendImages: true,
  enableTranslation: false,
  enableExtendedKnowledge: false,
});
contentConfigStateSegment.debugLabel = 'contentConfigStateSegment';
